module.exports = __webpack_public_path__ + "img/logo_white_menu.3a0ff9f5.svg";